import { Tag, TagSkeleton } from "@carbon/react";
import React from "react";

import { useGetCaseTypesSchemasQuery } from "src/graphql/anti-fraud/queries/caseTypes/CaseTypesSchemasQuery";
import { CaseTypeDefinition, Color } from "src/types/case";

// Composant pour quand on a déjà les définitions de case types
type CaseTypeTagProps = {
  caseTypeCode: string;
  caseTypeDefinitions?: CaseTypeDefinition[];
  fallbackType?: Color;
};

export const CaseTypeTag: React.FC<CaseTypeTagProps> = ({
  caseTypeCode,
  caseTypeDefinitions,
  fallbackType = "magenta",
}) => {
  if (!caseTypeCode) return null;

  const caseType = caseTypeDefinitions?.find((caseType) => caseType.code === caseTypeCode);

  return caseType ? (
    <Tag type={caseType.tag} title={caseType.label}>
      <span className="block truncate" title={caseType.label}>
        {caseType.label}
      </span>
    </Tag>
  ) : (
    <CaseTypeDefaultTag caseTypeCode={caseTypeCode} type={fallbackType} />
  );
};

type CaseTypeDefaultTagProps = {
  caseTypeCode: string;
  type: Color;
};

export const CaseTypeDefaultTag: React.FC<CaseTypeDefaultTagProps> = ({ caseTypeCode, type }) => {
  const { data: caseTypes, error, loading } = useGetCaseTypesSchemasQuery();

  if (loading) {
    return <TagSkeleton size="sm" />;
  }

  if (error) {
    return null;
  }

  const caseType = caseTypes?.find((caseType) => caseType.code === caseTypeCode);

  return caseType ? (
    <Tag type={type}>
      <span className="block truncate" title={caseType.name}>
        {caseType.name}
      </span>
    </Tag>
  ) : (
    <Tag type={type}>
      <span className="block truncate" title={caseTypeCode}>
        {caseTypeCode}
      </span>
    </Tag>
  );
};
